<template>
  <BottomSheet :show="show" @close="$emit('close')">
    <div class="flex justify-center -mt-12 mb-2">
      <div class="bg-primary rounded-full w-20 h-20 flex items-center justify-center shadow-lg border-4 border-white">
        <i class="bx bx-question-mark text-white text-4xl"></i>
      </div>
    </div>
    <div class="px-6 text-center">
      <h2 class="text-2xl font-bold mb-2 mt-2">Rispondi alle domande</h2>
      <p class="text-gray-500 mb-4" style="white-space: pre-line;">
        {{ question }}
      </p>
      <textarea
        v-model="answer"
        class="w-full rounded-2xl border border-gray-200 px-4 py-3 text-base focus:outline-none focus:ring-2 focus:ring-primary transition resize-none mb-4"
        rows="3"
        placeholder="Scrivi qui la tua risposta.."
      ></textarea>
      <div class="flex gap-3">
        <CuButton dark class="flex-1" @click="$emit('close')">Annulla</CuButton>
        <CuButton primary class="flex-1" @click="confirm">Conferma</CuButton>
      </div>
    </div>
  </BottomSheet>
</template>

<script>
import BottomSheet from './BottomSheet.vue'
import CuButton from '../cu/CuButton.vue'

export default {
  name: "CandidateQuestionsModal",
  components: { BottomSheet, CuButton },
  props: {
    show: { type: Boolean, default: false },
    question: { type: String, required: true }
  },
  data() {
    return {
      answer: ''
    }
  },
  methods: {
    confirm() {
      this.$emit('confirm', this.answer)
    }
  }
}
</script>
